module.exports = __webpack_public_path__ + "img/roofing_ttop.a1d97330.png";